<template>
  <div class="section fondu" :class="{'fonduenter': images['.key'] != null}">
    <span class="icon has-text-info help-btn">
      <a href="https://theadmin.thecompagnie.eu/doc?bloc=Media" target="_blank"><i class="fa fa-question-circle"></i></a>
    </span>

    <div class="card">
      <div class="card-header">
        <p class="card-header-title">Média</p>
        <span class="icon has-text-info help-btn">
          <a href="https://theadmin.thecompagnie.eu/doc?bloc=Paramètres" target="_blank"><i class="fa fa-question-circle"></i></a>
        </span>
      </div>
      <div class="card-content principal">
        <div class="content">
          <div class="card">
            <div class="card-header">
              <p class="card-header-title">Images</p>
            </div>
            <div class="card-content">
              <div class="content">
                <div class="gallery columns is-multiline is-centered" v-if="!media.hasOwnProperty('.value')">
                  <a class="img-container column is-4" v-for="(img, key) in images" :key="key" v-if="img.src && img.path">
                    <figure class="image is-128x128" style="border: 1px solid lightgrey; background-position: center; background-repeat: no-repeat;" :style="{ 'background-image': 'url(' + img.src + ')' }">
                    </figure>
                    <div class="info-tab"><div @click="deleteImage(img.path, key)" class="delete delete-button"></div> {{img.name}}</div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

import { mediaRef } from '@/admin/firebase_config'

export default {
  name: 'Media',
  data: function () {
    return {
    }
  },
  firebase: {
    // load settings as an object instead of array (default)
    media: {
      source: mediaRef,
      asObject: true
    }
  },
  computed: {
    images () {
      return this.media
    }
  },
  methods: {
    deleteImage (path, key) {
      let storageRef = firebase.storage().ref(path)
      var that = this
      storageRef.delete().then(function () {
        that.$firebaseRefs.media.child(key).remove()
      }).catch(function (error) {
        console.error(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.section{
  padding: 0 !important;
  padding-top: 1em !important;
}
.bulma .card .card-content.principal{
  padding: 0 !important;
}
.bulma .card-content{
  padding: 0 !important;
}
.bulma .columns{
  padding: 0 !important;
}
.bulma .column{
  padding: 0 !important;
}
.content{
  padding: 1em !important;
}
</style>



// WEBPACK FOOTER //
// src/admin/pages/Media.vue